import React from 'react';

import "../carruselLoMejor/carruselLoMejor.css"


const CarruselLoMejor = () => {
  return (
    <div className="loMejor">
      <div className="textLoMejor">
        <h2>LO MEJOR EN</h2>
        <h4>MOVILIDAD SOSTENIBLE</h4>
      </div>
    </div>
  );
}

export default CarruselLoMejor;
